<template>
  <div class="flexwrap">
    <component id="landingPageScienceBody" :is="isMobile?'carousel':'div'"
               :perPage="1" :minSwipeDistance="50" :paginationEnabled="true" :touchDrag="true" :autoplay="false" :loop="true"
               :autoplayTimeout="3500" paginationActiveColor="var(--goalColor)" paginationColor="#ffffff88" :paginationPadding="5" >
      <component class="scienceBloc" :is="isMobile?'slide':'div'">
        <h2 style=" grid-column: 1/3">Ce que disent les études <sup  v-tooltip="{content: html_papers, trigger: triggerMethod}" style="font-size: 0.6em;"><i class="fa-solid fa-circle-question"></i></sup></h2>

        <i class="fa-duotone fa-thumbs-up fa-swap-opacity"></i>
        <span>Regarder des séries dans une seconde langue <strong>permet bien de progresser dans cette langue.</strong></span>

        <i class="fa-duotone fa-closed-captioning"></i>
        <span>Regarder en <strong>sous-titré anglais</strong> mène à un <strong>meilleur apprentissage de vocabulaire.</strong> </span>

        <i class="fa-duotone fa-chart-line-up"></i>
        <div>
          3 éléments sont particulièrement important pour <strong>améliorer la compréhension</strong> d'une série en anglais

        </div>
        <div class="importantFeatures">
          <strong>Avoir plus de vocabulaire en amont.</strong>
          <strong>Regarder les épisodes avec sous-titre.</strong>
          <strong>Avoir des connaissances contextuelles.</strong>
        </div>

      </component>

      <div class="vertical-line" v-if="!isMobile"></div>

      <component class="scienceBloc" :is="isMobile?'slide':'div'">
        <h2 style=" grid-column: 1/3">Notre approche</h2>

        <i class="fa-duotone fa-face-vomit fa-swap-opacity"></i>
        <div>
          La plupart des élèves restent cependant sujets à des freins qui les empêchent de regarder les séries en VOST.
        </div>

        <i class="fa-duotone fa-hand-holding-medical"></i>
        <div>
          <span>Notre méthode vise donc à retirer les freins suivants</span>
          <li><strong>Choix de série non adapté</strong></li>
          Recommandation de série peu dense avec une vitesse de dialogues modérée
          <li><strong>Niveau en anglais insuffisant</strong></li>

          Enseignement du vocabulaire clé en amont et présentation du contexte de l'épisode (via le synopsis)
        </div>

      </component>



    </component>
    <span id="finalWarning">Attention, on note aussi que <strong>le premier épisode est généralement significativement plus difficile que les suivants.</strong>
          Il faudra donc quand même bien t'accrocher. Mais ne t'en fais pas, nous sommes là pour t'aider !</span>
  </div>


</template>

<script>
import {Carousel, Slide} from "vue-carousel";
import {mapGetters} from "vuex";

export default {
  name: "landingPageScience",
  components: {
    Carousel,
    Slide,},

  computed: {
    ...mapGetters('global', [
      'isMobile',
    ]),
    html_papers: function(){
      let val = this.isMobile?'90':'35'
      return '        <div  style="max-width: '+val+'vw; ">\n' +
          '          <ul style="font-style: italic; ">\n' +
          '            <li>\n' +
          '              Rodgers, Michael PH. "English language learning through viewing television: An investigation of comprehension, incidental vocabulary acquisition, lexical coverage, attitudes, and captions." (2013).\n' +
          '            </li>\n' +
          '<br/>\n' +
          '            <li>\n' +
          '              Frumuselu, Anca Daniela, et al. "Television series inside the EFL classroom: Bridging the gap between teaching and learning informal language through subtitles." Linguistics and Education 32 (2015).\n' +
          '            </li>\n' +
          '<br/>\n' +
          '            <li>\n' +
          '              Peters, Elke, and Stuart Webb. "Incidental vocabulary acquisition through viewing L2 television and factors that affect learning." Studies in Second Language Acquisition 40.3 (2018).\n' +
          '            </li>\n' +
          '          </ul>\n' +
          '        </div>'
    },


    triggerMethod: function() {
      if(this.isMobile) {
        return 'click'
      }
      return 'hover'
    }
  },
}
</script>

<style scoped>
  #landingPageScienceBody{
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    grid-gap: 1.5vw;
    font-size: 0.9em;
  }

  .scienceBloc{
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 1.5vw;
  }
  .scienceBloc>i{
    font-size: 1.8em;
  }
  .scienceBloc>i,strong{
    /*color: #caffec;*/
  }

  .importantFeatures{
    grid-column: 1/3;
    display: grid;
    grid-auto-columns: 1fr;
    grid-auto-flow: column;
    grid-gap: 0.5vw;
  }
  .importantFeatures>*{
    padding: 0.25vw;
    /*background-color: var(--standardColor);*/
    border-radius: 0.5vw;
    /*background-color: var(--goalBackgroundColor3);*/
    /*color: var(--standardColor);*/
    border: var(--goalBackgroundColor3) solid 0.1vw;
    font-size: 0.9vw;
  }

  .vertical-line{
    width: 0.3vw;
    border-radius: 0.3vw;
    height:100%;
    background-color: var(--goalBackgroundColor3);
    justify-self: center;
    color: #00000000;
  }

  #finalWarning{
    margin-top: 2vw;
  }

  @media screen and (max-device-width: 767px) {
    #landingPageScienceBody{
      height: fit-content;
      width: 100vw;
      display: block;
      justify-self: center;
      font-size: 1em;
      transform: translateX(-8vw);
    }

    .scienceBloc{
      max-width: 84vw;
      margin: 0 8vw 0 8vw;
    }
    .scienceBloc>i{
      font-size: 1.8em;
    }
    .scienceBloc>i,strong{
      /*color: #caffec;*/
    }

    .importantFeatures{
      grid-column: 1/3;
      display: grid;
      grid-auto-columns: 1fr;
      grid-auto-flow: column;
      grid-gap: 2vw;
    }
    .importantFeatures>*{
      padding: 1vw;
      /*background-color: var(--standardColor);*/
      border-radius: 2vw;
      /*background-color: var(--goalBackgroundColor3);*/
      /*color: var(--standardColor);*/
      border: var(--goalBackgroundColor3) solid 1px;
      font-size: 0.9em;
    }

    .vertical-line{
      width: 0.3vw;
      border-radius: 0.3vw;
      height:100%;
      background-color: var(--goalBackgroundColor3);
      justify-self: center;
      color: #00000000;
    }
  }
</style>